// @flow

import _ from 'lodash';

import trackingFunctions, { trackEvent } from './trackingFunctions';

const Data = {
  gaPageTrack: (path: string, userId: string) => {
    const metaData = {
      pagePath: path,
      pageTitle: _.get(document, ['title']),
      userId,
    };

    if (path.indexOf('/admin/') !== -1) {
      console.info('tracking for admin pages is disabled.');
      return;
    }

    trackEvent('clientSidePageView', metaData);
  },
  ...trackingFunctions,
};

export default Data;
